import { z } from "zod"

export const lastDashboardNavigationSchema = z.object({
    accountNumber: z.string(),
    propertyId: z.string(),
    agreementId: z.string().optional(),
})
